import { $service } from '@xt/client/experimental/request/service'
import $global from '@xt/client/store/global'
import type { CalligraphyJson } from './types.js'
import { action, observable } from 'mobx'

class Calligraphy {
  constructor() {}

  @observable dataSource: CalligraphyJson | null = null

  async loadJson() {
    if (!!this.dataSource) return

    const [err, data] = await $service<CalligraphyJson>({
      method: 'GET',
      url: '/mocks/activity-calligraphy.json',
      baseURL: $global.static
    })

    if (err) throw err

    this.updateDataSource(data)
  }

  @action
  updateDataSource(data: CalligraphyJson) {
    this.dataSource = data
  }
}

export default Calligraphy
